module.exports = __webpack_public_path__ + "img/sustainability.bc3e101.jpg";